<template>
  <div id="payment"></div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'StripeComponent',
  props: {
    clientSecret: {
      type: String,
      required: true,
    },
    data() {
      return {
        elements: null,
      };
    },
  },
  computed: {
    ...mapGetters('user', ['publicEmail', 'user']),
  },
  mounted() {
    const elements = this.$stripe.elements({
      clientSecret: this.$props.clientSecret,
      locale: 'en',
    });
    this.elements = elements;
    const payment = elements.create('payment', {
      defaultValues: {
        billingDetails: {
          email: this.publicEmail,
          name: `${this.user.firstName} ${this.user.lastName}`,
        },
      },
    });

    payment.mount('#payment');
  },
};
</script>

<style lang="scss" scoped>
</style>